import React from 'react';
import { SearchSource } from '../Enum/SearchSource';
import { useAppState } from '../../AppStateContext';

export const PopularSection = () => {
  const { kmcSettings, sugs, categories, products } = useAppState();
  const translations = window._THULEDATA._siteHeader.Translations;
  const popularTerms = kmcSettings?.root?.klevu_webstorePopularTerms;

  if (sugs.length || categories.length || products.length || !popularTerms?.length) return null;

  return (
    <div className="popular-section">
      <p className="paragraph--s section-sub-header mb-6">{translations?.QuickLinks}</p>
      <ul>
        {popularTerms.map((term, index) => (
          <li
            key={index}
            onClick={() => {
              const cleanTerm = term.replace(/<[^>]*>?/gm, '');
              window.location.href = `${window._THULEDATA._siteHeader.SearchPageLink.Url}?search=${cleanTerm}&source=${SearchSource.PopularSearches}`;
            }}
          >
            {term}
          </li>
        ))}
      </ul>
    </div>
  );
};
